// CellCog's public DeepResearch Bench claim, from ONE source (benchmarkClaim.json). Change it there;
// run marketing/scripts/check_benchmark_claim.py --verify for the text homes that cannot import it.
// Ruling (Nitish, Oct 21 2026): the claim is always dated and always linked to the live leaderboard;
// never ship an undated "#1". No em dashes in copy built from these.
import data from './benchmarkClaim.json';

export const BENCHMARK_CLAIM = data;
/** "#1 on DeepResearch Bench (October 2026)", the exact public wording. */
export const BENCHMARK_LABEL = data.label;
export const BENCHMARK_MONTH = data.month;
export const BENCHMARK_URL = data.leaderboardUrl;
export const BENCHMARK_VERIFIED_ON = data.verifiedOn;
export const BENCHMARK_VERIFIED_ON_ISO = data.verifiedOnIso;
export const BENCHMARK_RANK = data.rank;
export const BENCHMARK_AGENT = data.agent;
export const BENCHMARK_SCORE = data.score;
export const BENCHMARK_MODEL = data.model;
export const BENCHMARK_JUDGE = data.judge;
export const BENCHMARK_DIMENSIONS = data.dimensions;
export const BENCHMARK_PREVIOUS = data.previous;
export const BENCHMARK_STANDINGS = data.standings;
export const BENCHMARK_ENTRY_COUNT = data.standings.length;

/** Schema.org `award` string (Organization / SoftwareApplication JSON-LD). */
export const BENCHMARK_AWARD = `#1 on DeepResearch Bench (${data.month}), the public deep-research agent benchmark`;

/** The standings row for a display name, e.g. standingOf('OpenAI Deep Research').rank. */
export const standingOf = (agent) => data.standings.find((r) => r.agent === agent);

const DIMENSION_KEYS = ['comprehensiveness', 'insight', 'instructionFollowing', 'readability'];
/** True only if our entry has the top score on every judged dimension (computed, never typed). */
export const BENCHMARK_LEADS_EVERY_DIMENSION = DIMENSION_KEYS.every((k) => {
  const ours = Number(data.dimensions[k]);
  return data.standings.every((r) => r.us || Number(r[k]) < ours);
});
